import Education from '../../assets/Education.svg';
import Retail from '../../assets/Reatil.svg';
import Healthcare from '../../assets/Healthcare.svg';
import Estate from '../../assets/Estate.svg';
import Travel from '../../assets/Travel.svg';
import Banking from '../../assets/Banking.svg';
import Logistics from '../../assets/Logistics.svg';
import Fitness from '../../assets/Fitness.svg';
import Automotive from '../../assets/Automotive.svg';
import Services from '../../assets/Services.svg';
import Recruitment from '../../assets/Recruitment.svg';
import Insurance from '../../assets/Insurance.svg';
import Entertainment from '../../assets/Entertainment.svg';
import Charities from '../../assets/Charities.svg';
import Event from '../../assets/Event.svg';
import Hospitality from '../../assets/Hospitality.svg';

interface IProps {
  selectedValue: string;
  onSelectChange: (val: string) => void;
  errors: any;
}

const SelectBusinessType = (props: IProps) => {
  const { selectedValue, onSelectChange, errors } = props;
  const businessTypeList = [
    {
      name: 'Education',
      icon: Education
    },
    {
      name: 'Ecommerce',
      icon: Retail
    },
    {
      name: 'Healthcare',
      icon: Healthcare
    },
    {
      name: 'Real Estate',
      icon: Estate
    },
    {
      name: 'Travel',
      icon: Travel
    },
    {
      name: 'Banking',
      icon: Banking
    },
    {
      name: 'Logistics',
      icon: Logistics
    },
    {
      name: 'Fitness',
      icon: Fitness
    },
    {
      name: 'Automotive',
      icon: Automotive
    },
    {
      name: 'Services',
      icon: Services
    },
    {
      name: 'Recruitment',
      icon: Recruitment
    },
    {
      name: 'Insurance',
      icon: Insurance
    },
    {
      name: 'Entertainment',
      icon: Entertainment
    },
    {
      name: 'Charities',
      icon: Charities
    },
    {
      name: 'Event',
      icon: Event
    },
    {
      name: 'Hospitality',
      icon: Hospitality
    },
    {
      name: 'Others'
    }
  ];
  return (
    <div className="-mt-2 flex flex-col gap-2.5">
      <label>Select business type</label>
      <div className="grid grid-cols-4 gap-2">
        {businessTypeList.map((item: any, index: number) => (
          <div
            key={index}
            className={`rounded-lg cursor-pointer flex items-center gap-2 px-2 py-1 text-xs ${selectedValue === item.name ? 'bg-[#006BEA]' : 'bg-[#343434]'}`}
            onClick={() => onSelectChange(item.name)}
          >
            {item.icon ? (
              <img src={item.icon} className="h-4 w-4 md:h-6 md:w-6" />
            ) : (
              <div className="h-4 w-4 md:h-6 md:w-6" />
            )}
            <label className="cursor-pointer text-[7px] md:text-xs">{item.name}</label>
          </div>
        ))}
      </div>
      {errors && <span className="error ps-1 text-sm text-[#ff4c4c]">{errors}</span>}
    </div>
  );
};

export default SelectBusinessType;
